<template>
  <div class="game-hits">
    <div class="text-h6">
      Pelin lyönnit
    </div>
    <v-select
      class="mt-4"
      v-model="selectedPlayer"
      :items="allPlayers"
      :item-text="player => `${player.num}. ${player.player_name}`"
      item-value="id"
      label="Suodata pelaajan mukaan"
      clearable
      dense
    ></v-select>

    <div v-if="loading_events || loading_game_players" class="text-center pa-2 grey--text">
      Ladataan...
    </div>
    <div v-else>
      <div v-for="(event, index) in filteredEvents" :key="event.event_id">
        <div v-if="shouldShowPhaseTitle(event, index)" class="text-subtitle-2 font-weight-medium pa-1">
          {{ event.game_phase.jakso }}J
          {{ event.game_phase.inning }}{{ event.game_phase.lopettava ? 'L' : 'A' }}
        </div>
        <v-card
          v-no-focus
          class="mb-1"
          outlined
          @click="seekToEvent(event)"
        >
          <v-card-text class="py-1 px-2 d-flex align-center">
            <span class="text-body-2">{{ event.hitter_name }}</span>
            <v-spacer></v-spacer>
            <span class="text-caption grey--text mr-2">
              <span v-for="n in event.outs" :key="n" class="red--text">✕</span>
            </span>
            <span class="text-caption grey--text mr-2">{{ event.bases_state }}</span>
            <div
              class="hit-outcome-indicator"
              :class="{
                'green': event.hit_outcome === 'karkilyonti',
                'red': event.hit_outcome === 'palo',
                'grey': event.hit_outcome === 'vapaa',
                'yellow': event.hit_outcome === 'haava',
                'lightyellow': event.hit_outcome === 'haava_kt',
                'lightgreen': event.hit_outcome === 'takaeteneminen',
                'lightred': event.hit_outcome === 'takapalo'
              }"
            ></div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      selectedPlayer: null
    }
  },
  computed: {
    ...mapGetters('analysis', [
      'events',
      'loading_events'
    ]),
    ...mapGetters('game', [
      'loading_game_players',
      'game_players'
    ]),
    allPlayers() {
      if (!this.game_players) return []
      return [...this.game_players.home, ...this.game_players.away]
    },
    filteredEvents() {
      if (!this.selectedPlayer) return this.events
      return this.events.filter(event => event.hitter_id === this.selectedPlayer)
    }
  },
  methods: {
    ...mapActions('player', [
      'seek'
    ]),
    seekToEvent(event) {
      this.seek(event.starttime - 2)
    },
    shouldShowPhaseTitle(event, index) {
      if (index === 0) return true
      const prevEvent = this.filteredEvents[index - 1]
      return (
        prevEvent.game_phase.inning !== event.game_phase.inning ||
        prevEvent.game_phase.lopettava !== event.game_phase.lopettava
      )
    },
  }
}
</script>

<style scoped>
.game-hits {
  padding: 1rem;
}

.phase-group {
  margin-bottom: 1.5rem;
}

.phase-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.event-item {
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.event-item:hover {
  background-color: #f7fafc;
}

.event-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.hitter {
  font-weight: 500;
  color: #2d3748;
}

.details {
  font-size: 0.875rem;
  color: #718096;
}

.loading {
  text-align: center;
  padding: 1rem;
  color: #718096;
}

.hit-outcome-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-left: 4px;
}

.hit-outcome-indicator.green {
  background-color: #4CAF50;
}

.hit-outcome-indicator.red {
  background-color: #F44336;
}

.hit-outcome-indicator.grey {
  background-color: #9E9E9E;
}

.hit-outcome-indicator.yellow {
  background-color: #FFC107;
}

.hit-outcome-indicator.lightgreen {
  background-color: #4CAF50;
  border: 2px solid black;
}

.hit-outcome-indicator.lightred {
  background-color: #F44336;
  border: 2px solid black;
}

.hit-outcome-indicator.lightyellow {
  background-color: #FFC107;
  border: 2px solid black;
}

</style>